import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from "@angular/forms";
import { BehaviorSubject, Subscription } from "rxjs";
import { AuthService } from "../../../../services/auth.service";
import { NoteType } from '../../../../common/models/note-type.enum';
import { Note } from "../../../../common/models/note.model";
import { NoteRelatedItemType } from "../../../../common/models/note_relatedItemType.enum";
import { RetentionPolicy } from '../../../../common/models/retention-policy.model';
import { NoteUrgency } from '../../../../common/models/note-urgency.enum';
import { genId } from "../../../../core/services/genId";

@Component({
    selector: 'reservation-notes',
    templateUrl: './reservation-notes.component.html',
    styleUrls: ['./reservation-notes.component.scss', '../../../../common/components/notes/notes.component.scss'],
    standalone: false
})
export class ReservationNotesComponent implements OnInit {
    form: FormGroup;

    private _notes: Note[];

    get disableSave(): boolean {
        if (this.form == null) return false;
        const contentCtrl = this.form.get("content");
        if (contentCtrl == null) return false;
        return contentCtrl.invalid || this.savingNote.value;
    }
    @Input() enabled: boolean = true;
    @Output() errorOccurred: EventEmitter<any> = new EventEmitter<any>();
    @Input() label: string = "Notes";

    get notes(): Note[] {
        return this._notes;
    }

    @Input() set notes(data: Note[]) {
        if (data == null) data = [];
        data = data.sort((a, b) => {
            if (a.createdDate < b.createdDate) return -1;
            if (b.createdDate < a.createdDate) return 1;
            return 0;
        });
        this._notes = data;
    }

    @Output() noteAdded: EventEmitter<Note> = new EventEmitter<Note>();
    @Output() noteDeleted: EventEmitter<number> = new EventEmitter<number>();

    noteType = NoteType;

    pendingNote: Note;

    @Input() reportId: string;

    savingNote: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    subscription: Subscription = new Subscription;

    constructor(private auth: AuthService) { }

    ngOnInit() {

    }

    ngOnDestroy() {
        if (this.subscription) this.subscription.unsubscribe();
    }


    addNote(): void {
        this.pendingNote = {
            id: genId(),
            documentType: "Note",
            relatedItemType: NoteRelatedItemType.Well,
            createdDate: (new Date()).toUTCString(),
            type: NoteType.Internal,
            text: "",
            isDeleted: false,
            retentionPolicy: {} as RetentionPolicy,
            noteUrgency: NoteUrgency.LowPriority,
            referenceUri: "",
            createdBy: this.auth.User.displayName,
            createdById: this.auth.User.id
        } as Note;
    }

    cancel(): void {
        this.pendingNote = null;
    }

    deleteNote(index: number): void {
        this.noteDeleted.emit(index);
    }

    editorFormBuilt(group: FormGroup): void {
        this.form = group;
    }

    getNoteDate(note: Note): string {
        const date = new Date(note.createdDate);
        return date.toLocaleDateString();
    }

    submitNote(): void {
        this.pendingNote.createdDate = (new Date()).toUTCString();
        this.pendingNote.text = this.form.get("content").value;
        this.noteAdded.emit(this.pendingNote);
        this.pendingNote = null;
    }

    throwError(err: any): void {
        this.errorOccurred.emit(err);
    }
}
